module.exports = __webpack_public_path__ + "static/media/shortSleeves.25596414.jpg";